export const localConfig = {
  simple_flag: {
    enabled: true,
  },
  simple_disabled_flag: {
    enabled: false,
  },
  simple_variation: {
    enabled: true,
    variation: 'other_variation',
  },
  content_program_search_success_score: {
    enabled: true,
    meta_data: {
      OVERRIDDEN_USER_IDS: '1,2',
    },
    variation: 'active',
  },
  dsj_divert_to_rp_search: {
    enabled: false,
  },
  vas_rbc_gic_extended_countries: {
    enabled: false,
  },
  vas_loan_followup_form: {
    enabled: true,
  },
};
